import { ReservationInputComponentModule } from '@b2b/common/components/reservation-input';
import { PaymentDirectiveModule, PromptSaveDirectiveModule } from '@b2b/common/directives';
import { LoadACMECheckoutResolver, ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OrderDataResolver } from '../resolvers';
import { OrdersEditControllerModule } from './controllers/OrdersEditController';

export const OrdersEditView = angular
  .module('acme.view.application.orders.edit', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    PaymentDirectiveModule,
    PromptSaveDirectiveModule,
    'acme.common.directive.integer',
    ReservationInputComponentModule,
    OrdersEditControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.orders.edit',
      url: '/:orderId/edit',
      views: {
        'subview-main': {
          controller: 'OrdersEditController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/edit/edit.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Order',
        /** Secure With Permissions **/
        permissions: ['ORDER_UPDATE', 'ACCT_ORDERS_UPDATE'],
      },
      resolve: {
        OrderData: OrderDataResolver(),
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        ACMECheckout: LoadACMECheckoutResolver(),
      },
    });
  }).name;
